import { SkipNav } from 'shared/domains/common-ui';
import { DesktopNavigationProvider } from './components/DesktopNavigation';
import { MobileNavigationProvider } from './components/MobileNavigation';
import { Sidebar } from './components/Sidebar';
import { PageContainer } from './styled';
export function PageLayout(props) {
    const { children } = props;
    const startOfContentId = 'start-of-content';
    return (<DesktopNavigationProvider>
      <MobileNavigationProvider>
        <SkipNav target={startOfContentId}/>
        <PageContainer>
          <Sidebar />
          <div id={startOfContentId}/>
          {children}
        </PageContainer>
      </MobileNavigationProvider>
    </DesktopNavigationProvider>);
}
